/**
 * Created by RaoMeng on 2018/11/8
 * Desc: 通讯录列表
 */

import React, {Component} from 'react'
import PhonesBean from 'model/PhonesBean'
import {Icon, List, message, Skeleton} from 'antd'
import PhonesItem from "../../components/PhonesItem";
import 'css/phones.css'
import {getStrValue, isObjEmpty} from "../../utils/common";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import {Toast, SearchBar} from "antd-mobile";
import RefreshLayout from "../../components/RefreshLayout";
import {connect} from 'react-redux'

const mPageSize = 10
let mPageIndex = 0
let mSearchKey = ''

class PhonesList extends Component {

    constructor() {
        super()

        this.state = {
            phonesList: [],
            teacherList: [],
            classTitle: '',
            isLoading: true,
            isRefreshing: false,
            searchKey: '',
            searchText: '',
            searchHint: '',
            schoolTitle: '',
        }
    }

    componentDidMount() {
        document.title = '通讯录'

        this.title = this.props.match.params.classTitle;
        this.mType = this.props.match.params.type
        if (this.props.match.params.classId) {
            this.classId = this.props.match.params.classId;
        }
        if (this.title) {
            this.setState({
                classTitle: this.title
            })
        }

        if (this.mType === 'teacher') {
            this.setState({
                searchHint: '搜索学生'
            })
        } else if (this.mType === 'parent') {
            this.setState({
                searchHint: '搜索老师',
                schoolTitle: this.classId
            })
        }

        Toast.loading('', 0)
        mPageIndex = 0
        this.loadPhones()
        mPageIndex = 0
        this.getTeacherPhones()
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const {phonesList, classTitle, schoolTitle, isLoading, isRefreshing, searchHint, searchKey, searchText, teacherList} = this.state

        return (
            <div className='phone-select-root' style={{height: '100%', maxHeight: '100vh'}}>
                <div style={{height: '35px'}} className={isObjEmpty(classTitle) ? 'displayNone' : 'phones-list-header'}>{classTitle}</div>
                <div style={{height: '35px'}} className={isObjEmpty(schoolTitle) ? 'displayNone' : 'phones-list-header'}>{schoolTitle}</div>

                    <SearchBar placeholder={searchHint} maxLength={20}
                               value={searchText} onSubmit={this.searchSubmit}
                               onChange={this.searchChange} onClear={this.searchClear}
                               onCancel={this.searchCancel}/>
                    {/*<div className={isObjEmpty(classTitle) ? 'displayNone' : 'gray-line'} style={{height: '1px'}}></div>*/}

                <RefreshLayout
                    refreshing={isRefreshing}
                    onRefresh={this.loadPhones}>
                    <Skeleton loading={isLoading} active paragraph={{rows: 3}}>
                        <List className='phones-list-layout'
                              dataSource={phonesList}
                              renderItem={phonesBean => (
                                  <List.Item>
                                      <PhonesItem phonesBean={phonesBean}/>
                                  </List.Item>
                              )}/>
                    </Skeleton>
                </RefreshLayout>
                {/*{isObjEmpty(schoolTitle) ? '':
                <RefreshLayout
                    refreshing={isRefreshing}
                    onRefresh={this.getTeacherPhones}>
                    <Skeleton loading={isLoading} active paragraph={{rows: 3}}>
                        <List className='phones-list-layout'
                              dataSource={teacherList}
                              renderItem={phonesBean => (
                                  <List.Item>
                                      <PhonesItem phonesBean={phonesBean}/>
                                  </List.Item>
                              )}/>
                    </Skeleton>
                </RefreshLayout>
                }*/}
            </div>
        )
    }

    searchChange = (value) => {
        mSearchKey = value
        this.setState({
            searchText: value
        })
    }

    searchClear = (e) => {
        if (!isObjEmpty(this.state.searchKey)) {
            mPageIndex = 0
            this.setState({
                isLoading: true,
                isRefreshing: false,
                searchText: '',
                searchKey: ''
            }, () => {
                this.loadPhones()
            })
        }

    }

    searchCancel = (e) => {
        console.log(e)
    }

    searchSubmit = (value) => {
        mPageIndex = 0
        this.setState({
            isLoading: true,
            isRefreshing: false,
            searchKey: value.trim()
        }, () => {
            this.loadPhones()
        })
    }

    loadPhones = () => {
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {
        }

        if (this.mType == 'parent') {
            if(this.props.userInfo.user.student != '') {
                this.url = API.GET_TEACHER_PHONES
                this.params = {
                    stuId: this.props.userInfo.user.student.stuId
                }
            }else{
                this.url = API.TEACHER_PHONES_LIST
                this.params = {
                    schoolName: this.classId,
                    teacherId: this.props.userInfo.user.userFunId,
                }
            }
            this.getPhones()
        } else if (this.mType == 'teacher') {
            this.url = API.GET_PARENT_PHONES
            this.params = {
                clazzId: this.classId
            }
            this.getPhones()
        } else {
            Toast.hide()
            this.setState({
                isRefreshing: false
            })
        }
    }

    getTeacherPhones = () => {
        mPageIndex++
        console.log(mPageIndex)
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {

        }

        const {teacherList} = this.state
        if (mPageIndex === 1) {
            teacherList.length = 0
        }

        fetchPost(API.TEACHER_PHONES_LIST, {
            teacherId: this.props.userInfo.user.userFunId,
            selectKey: '',
            schoolName: this.classId,
            pageIndex: mPageIndex,
            pageSize: mPageSize
        }).then(response => {
            Toast.hide();

            if (response && response.data && response.data.length > 0) {
                response.data.map((item, index) => {
                    let phoneBean = new PhonesBean()
                    phoneBean.icon = require('imgs/ic_head' + (index % 15 + 1) + '.png')
                    phoneBean.icon = getStrValue(item, 'teacherPhoto')
                    phoneBean.name = getStrValue(item, 'teacherName')
                    phoneBean.phone = [getStrValue(item, 'userPhone')]
                    // phoneBean.claName = getStrValue(item, 'schName')
                    phoneBean.children = [getStrValue(item, 'schoolNameDept')]
                    phoneBean.withSchool = [getStrValue(item, 'teacherWithSchool')]
                    phoneBean.schoolName = [getStrValue(item, 'schoolName')]
                    phoneBean.teacherLists = [getStrValue(item, 'teacherList')]

                    teacherList.push(phoneBean)
                })
            } else {
                if (mPageIndex > 1) {
                    mPageIndex--
                }
                Toast.info("暂无老师的通讯录数据，谢谢！", 2)
            }

            this.setState({
                teacherList,
                isPhonesLoading: false,
                isRefreshing: false,
            })

        }).catch(error => {
            Toast.hide();

            if (mPageIndex > 1) {
                mPageIndex--
            }
            this.setState({
                isRefreshing: false,
                isPhonesLoading: false,
            })
            if (typeof error === 'string') {
                message.error(error)
            }
        })
    }

    getPhones = () => {
        mPageIndex++
        console.log(mPageIndex)

        const {phonesList, searchKey} = this.state
        if (mPageIndex === 1) {
            phonesList.length = 0
        }

        fetchPost(this.url, {
            pageIndex: mPageIndex,
            pageSize: mPageSize,
            selectKey: searchKey,
            ...this.params
        }).then(response => {
            Toast.hide();

            if (response && response.data) {
                if (this.mType == 'parent') {
                    response.data.forEach((item, index) => {
                        let phoneBean = new PhonesBean()

                        phoneBean.icon = require('imgs/ic_head' + (index % 15 + 1) + '.png')
                        phoneBean.icon = getStrValue(item, 'teacherPhoto')
                        phoneBean.name = getStrValue(item, 'teacherName')
                        phoneBean.subjectName = getStrValue(item, 'teacherPhone')
                        phoneBean.children = [getStrValue(item, 'schoolNameDept')]
                        phoneBean.withSchool = [getStrValue(item, 'teacherWithSchool')]
                        phoneBean.schoolName = [getStrValue(item, 'schoolName')]
                        phoneBean.claName = this.title

                        phoneBean.phone = [getStrValue(item, 'userPhone')]
                        phonesList.push(phoneBean)
                    })
                } else if (this.mType == 'teacher') {
                    response.data.forEach((item, index) => {
                        let phoneBean = new PhonesBean()
                        let phones = []
                        phoneBean.icon = require('imgs/ic_head' + (index % 15 + 1) + '.png')
                        phoneBean.icon = getStrValue(item, 'stuPhoto')
                        phoneBean.name = getStrValue(item, 'stuName')
                        phoneBean.claName = this.title

                        if (item.parentsDOS && item.parentsDOS.length > 0) {
                            item.parentsDOS.forEach((ite, ind) => {
                                phoneBean.children.push(getStrValue(ite, 'parentsName'))
                                phones.push(getStrValue(ite, 'userPhone'))
                            })
                        }

                        // if (phones.length > 0) {
                        phoneBean.phone = phones
                        // }

                        phonesList.push(phoneBean)
                    })
                }
            } else {
                if (mPageIndex > 1) {
                    mPageIndex--
                }
            }

            this.setState({
                phonesList,
                isLoading: false,
                isRefreshing: false,
            })
        }).catch(error => {
            Toast.hide()

            if (mPageIndex > 1) {
                mPageIndex--
            }
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常')
            }

            this.setState({
                isLoading: false,
                isRefreshing: false,
            })
        })
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PhonesList)